export { DetalizationModal } from './Detalization';
